'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerDiscountsComponent = exports.sellerDiscountsComponent = {
    template: require('./discounts.html'),
    bindings: {
        seller: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "productOverviewService", "Enums", "common", "sellerService", "gettextCatalog", "Analytics", function controller($scope, $state, productOverviewService, Enums, common, sellerService, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;

        function init() {

            if (!vm.seller) {
                $state.go('error');
            }

            common.navigationMenu.setSellersActive();
            common.setTitle(vm.seller.name + ' ' + gettextCatalog.getString('discounts'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/discounts', vm.seller.name + ' ' + gettextCatalog.getString('discounts'));

            vm.productOverviewModel = productOverviewService.init(Enums.searchContext.seller.id);

            // sellerService.getSellerTotalPriceDiscounts(vm.seller.id)
            //              .then((totalPriceDiscounts) => {
            //                  vm.totalPriceDiscounts = totalPriceDiscounts;
            //              });

            productOverviewService.getSellerDiscounts(true, vm.productOverviewModel, vm.seller.id).then(function (model) {
                vm.productOverviewModel = model;
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getSellerDiscounts(false, vm.productOverviewModel, vm.seller.id).then(function (model) {
                    vm.productOverviewModel = model;
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }).catch(function () {
                    $state.go('error', {}, {
                        location: false
                    });
                });
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/discounts.js
// module id = 1019
// module chunks = 0